import React from 'react';
import styled from 'styled-components';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  align?: 'left' | 'center' | 'right';
  className?: string;
}

const HeaderContainer = styled.div<{ $align?: string }>`
  margin-bottom: var(--spacing-md);
  text-align: ${(props) => props.$align || 'center'};
`;

const PageTitle = styled.h1`
  margin-bottom: var(--spacing-sm);
`;

const PageSubtitle = styled.p<{ $align?: string }>`
  font-size: 1.2rem;
  font-weight: 300;
  opacity: 0.8;
  max-width: 800px;
  margin: ${(props) => (props.$align === 'center' ? '0 auto' : '0')};
  font-family: var(--font-body);
`;

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  align = 'center',
  className,
}) => {
  return (
    <HeaderContainer $align={align} className={className}>
      <PageTitle>{title}</PageTitle>
      {subtitle && <PageSubtitle $align={align}>{subtitle}</PageSubtitle>}
    </HeaderContainer>
  );
};

export default PageHeader;
